/**
 * Writes data to clipboard.
 *
 * @see https://stackoverflow.com/a/30810322/4664371
 * @see https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/Interact_with_the_clipboard
 * @param  {string} data Data to write to clipboard.
 */
export const writeToClipboard = async (data) => {
    if (navigator.clipboard) {
        await navigator.clipboard.writeText(data);
    } else {
        const tempInput = document.createElement('input');
        tempInput.value = data;

        tempInput.style.width = 0;
        tempInput.style.height = 0;
        tempInput.style.visibility = 'none';

        document.body.append(tempInput);
        tempInput.select();

        document.execCommand('copy');

        document.body.removeChild(tempInput);
    }
};
